var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_1409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 0H0.999998C0.447 0 0 0.441481 0 0.987652V46.4198C0 46.9659 0.447 47.4074 0.999998 47.4074H23V57.2839H20V59.2593H24H36V57.2839H25V47.4074H35V45.4321H24H2V37.5309H5H34H35V35.5556H34H6V5.92593H54V21.7284H56V4.93827C56 4.3921 55.553 3.95061 55 3.95061H5C4.447 3.95061 4 4.3921 4 4.93827V35.5556H2V1.97531H58V21.7284H60V0.987652C60 0.441481 59.553 0 59 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9995 25.6797H38.9995C38.4465 25.6797 37.9995 26.1212 37.9995 26.6673V58.2723C37.9995 58.8184 38.4465 59.2599 38.9995 59.2599H58.9995C59.5525 59.2599 59.9995 58.8184 59.9995 58.2723V26.6673C59.9995 26.1212 59.5525 25.6797 58.9995 25.6797ZM57.9995 27.6549V31.6056H39.9995V27.6549H57.9995ZM57.9995 33.5809V52.3464H39.9995V33.5809H57.9995ZM39.9995 57.2846V54.3216H57.9995V57.2846H39.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9995 28.6426H46.9995V30.6178H50.9995V28.6426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 43.4559H55C55.553 43.4559 56 43.0145 56 42.4682V36.5423C56 35.9962 55.553 35.5547 55 35.5547H43C42.447 35.5547 42 35.9962 42 36.5423V42.4682C42 43.0145 42.447 43.4559 43 43.4559ZM44 37.53H54V41.4806H44V37.53Z",
    fill: "#A85ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 45.4316H42V47.407H56V45.4316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 48.3945H42V50.3699H56V48.3945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9995 18.7665V8.88997C51.9995 8.34382 51.5525 7.90234 50.9996 7.90234H8.99949C8.44651 7.90234 7.99951 8.34382 7.99951 8.88997V18.7665C7.99951 19.3127 8.44651 19.7542 8.99949 19.7542H50.9996C51.5525 19.7542 51.9995 19.3127 51.9995 18.7665ZM49.9995 17.7789H9.99954V9.8776H49.9995V17.7789Z",
    fill: "#A85ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99949 21.7266C8.44651 21.7266 7.99951 22.168 7.99951 22.7143V32.5908C7.99951 33.1369 8.44651 33.5784 8.99949 33.5784H20.9995C21.5525 33.5784 21.9995 33.1369 21.9995 32.5908V22.7143C21.9995 22.168 21.5525 21.7266 20.9995 21.7266H8.99949ZM19.9995 31.6032H9.99954V23.7019H19.9995V31.6032Z",
    fill: "#A85ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 22.7168H24V24.6921H32V22.7168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 26.666H24V28.6413H34V26.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 30.6172H24V32.5925H34V30.6172Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_1409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxDesign);
export default __webpack_public_path__ + "static/media/UX Design.f28822c787fe3513f13fa06ab78741ab.svg";
export { ForwardRef as ReactComponent };